<template>
  <div
    class="language-selector primary"
    @mouseleave="scheduleClose"
  >
    <span
      ref="buttonRef"
      @click="toggleMenu"
      @mouseenter="openMenu"
    >
      {{ selectedLanguage.flag }}
    </span>
    <div
      v-if="isOpen"
      ref="menuRef"
      @mouseenter="cancelClose"
      class="language-list column__start p-8 g-4 mt-8"
    >
      <div
        v-for="language in languages"
        :key="language.code"
        @click="changeLocale(language.code)"
        class="language-item"
      >
        {{ language.label }}
      </div>
    </div>
  </div>
</template>

<script>
import {localStorageGateway} from '@/api'

export default {
  name: 'LanguageSelector',
  data: () => ({
    languages: [
      {code: 'en', label: '🇺🇸 English', flag: '🇺🇸'},
      {code: 'pt', label: '🇧🇷 Português', flag: '🇧🇷'},
    ],
    isOpen: false,
    closeTimeout: null,
  }),
  computed: {
    selectedLanguage() {
      return this.languages.find((lang) => lang.code === this.$i18n.locale) || this.languages[0]
    },
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
      localStorageGateway.setItem('locale', locale)
      this.isOpen = false
    },
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    openMenu() {
      this.isOpen = true
    },
    scheduleClose() {
      this.closeTimeout = setTimeout(() => {
        this.isOpen = false
      }, 200)
    },
    cancelClose() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout)
      }
    },
    handleClickOutside(event) {
      if (
        this.$refs.buttonRef &&
        !this.$refs.buttonRef.contains(event.target) &&
        this.$refs.menuRef &&
        !this.$refs.menuRef.contains(event.target)
      ) {
        this.isOpen = false
      }
    },
  },
  mounted() {
    let locale = localStorageGateway.getItem('locale')
    if (locale) {
      this.$i18n.locale = locale
    }
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/functions';

.language-selector {
  cursor: pointer;
  position: relative;
  font-weight: bold;

  .language-list {
    display: flex;
    position: absolute;
    right: 0;
    background-color: get-color(surface, 2);
    border-radius: 8px;
    border: 0.5px solid get-color(onsurface, 4);

    .language-item {
      white-space: nowrap;
      min-width: 120px;
      color: rgba(#fff, 0.8);

      &:hover {
        color: rgba(#fff, 1);
      }
    }
  }
}
</style>
